(() => {
  const hostId = 'app-embed-container-1183316';
  const styleId = 'anom-newsletter-popup-spacing';
  function apply() {
    const root = document.getElementById(hostId)?.shadowRoot;
    if (!root || root.getElementById(styleId)) return;
    const style = document.createElement('style');
    style.id = styleId;
    style.textContent = `
      section:has(> h2) { gap: 14px !important; margin-bottom: 20px !important; }
      section:has(> h2) > h2 { margin: 0 !important; }
      section:has(> h2) p { margin: 0 !important; }
    `;
    root.appendChild(style);
  }
  apply();
  const observer = new MutationObserver(apply);
  observer.observe(document.documentElement, { childList: true, subtree: true });
  // The embed attaches its shadow root asynchronously without a light-DOM mutation.
  const timer = setInterval(apply, 1000);
  const stop = () => { observer.disconnect(); clearInterval(timer); };
  setTimeout(stop, 120000);
  addEventListener('pagehide', stop, { once: true });
})();
